import * as types from './mutation-types.js'
import { getTenantId} from "@/Helpers/Helper";
import {SET_ORDERS_TABLE_STATUS , SET_TABLE_ORDERS} from "@/store/modules/table/mutation-types";
import {INCREMENT_ROOM_ORDER_COUNT, REMOVE_ROOM_ORDER_COUNT} from "@/store/modules/room/mutation-types";
const tenantId = getTenantId()
const audio = new Audio('/assets/audio/audio.mp3')

let audioUnlocked = false
function unlockAudio() {
    if (audioUnlocked) return
    audioUnlocked = true
    audio.muted = true
    audio.play().then(() => {
        audio.pause()
        audio.currentTime = 0
        audio.muted = false
    }).catch(() => {})
}
;['click', 'touchstart', 'keydown'].forEach(evt => {
    document.addEventListener(evt, unlockAudio, { once: true })
})

const useNotify = function (table_id , message) {
    if (!("Notification" in window)) {}
    else if (Notification.permission === "granted") {
         new Notification(`${message} ${table_id}`);
    }

    else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
                 new Notification(`${message} ${table_id}`);
            }
        });
    }
}

export const setUpOrder = ({ commit, dispatch, state , rootState }, $restaurantId) => {
    Echo.channel(`New.Order.${tenantId + $restaurantId}`)
        .listen('.KoboEat\\v1\\Order\\Events\\OrderCreatedEvent', (e) => {
            commit('table/' + SET_TABLE_ORDERS, e.order, {root: true})
            commit('room/' + INCREMENT_ROOM_ORDER_COUNT, e.order.tables, {root: true})
            e.order?.tables?.forEach(table => {
                useNotify(table.name,'Nouvelle commande sur la table ')
            })
            audio.play().catch(() => {})

        })
    ;

    Echo.channel(`Update.Order.${tenantId + $restaurantId}`)
        .listen('.KoboEat\\v1\\Order\\Events\\OrderUpdatedEvent', (e) => {
            commit(types.UPDATE_ORDER, e.order)
        })
    ;

    Echo.channel(`Validate.Order.${tenantId + $restaurantId}`)
        .listen('.KoboEat\\v1\\Order\\Events\\OrderValidatedEvent', (e) => {
            commit(types.VALIDATE_ORDER, e.order)
        })
    ;

    Echo.channel(`Validate.Orders.${tenantId + $restaurantId}`)
        .listen('.KoboEat\\v1\\Order\\Events\\OrdersValidatedEvent', (e) => {
            commit(types.SET_ORDERS, e.orders)
            commit('table/' + SET_ORDERS_TABLE_STATUS, e.tables, {root: true})
            commit('room/' + REMOVE_ROOM_ORDER_COUNT, { tables : e.tables , count : e.orders?.length ?? 0  } , {root: true})
        })
    ;

    Echo.channel(`Cancel.Order.${tenantId + $restaurantId}`)
        .listen('.KoboEat\\v1\\Order\\Events\\OrderCanceledEvent', (e) => {
            commit(types.SET_ORDER, e.order)
            commit('table/' + SET_ORDERS_TABLE_STATUS, e.tables, {root: true})
            commit('room/' + REMOVE_ROOM_ORDER_COUNT, { tables : e.tables , count : 1  } , {root: true})
        })
    ;


}

export const callServer = ({ commit, dispatch, state , rootState }) => {
    rootState.callTables?.forEach(table => {
        Echo.channel(`Call.Server.${tenantId + table.id}`)
            .listen('.KoboEat\\v1\\Contact\\Events\\CallServerEvent', (e) => {
                useNotify(table.name,'Appel d\'une serveuse sur la table ')
                audio.play().catch(() => {})
            })
        ;
    })


}


export const loadTableOrders = ({ commit, dispatch, state }, table_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`table/${table_id}/orders?details=true`).then((response) => {
            commit(types.LOAD_ORDERS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const validateOrders = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`validate/orders`,data).then((response) => {
            commit(types.SET_ORDERS, response.data.orders)
            commit('table/' + SET_ORDERS_TABLE_STATUS, response.data.tables, {root: true})
            commit('room/' + REMOVE_ROOM_ORDER_COUNT, { tables : response.data.tables , count : data.orders?.length ?? 0  } , {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const cancelOrder = ({ commit, dispatch, state }, order) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`cancel/${order}/order`).then((response) => {
            commit(types.SET_ORDER, response.data.order)
            commit('table/' + SET_ORDERS_TABLE_STATUS, response.data.tables, {root: true})
            commit('room/' + REMOVE_ROOM_ORDER_COUNT, { tables : response.data.tables , count : 1  } , {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const updateOrder = ({ commit, dispatch, state }, {order, data}) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`user/set/${order}/order`, data).then((response) => {
            commit(types.CHANGE_ORDER, {
                orderId: order, 
                order: data.order
            })
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}








